module.exports = __webpack_public_path__ + "static/media/timelineDot.a0f002d0.svg";